export const DIMENSION_POSITION_ATTRIBUTE = {
	height: 'top',
	width: 'left'
}

export const POSITION_COMPLEMENTS = {
	bottom: 'top',
	left: 'right',
	right: 'left',
	top: 'bottom'
};

// We know the top/left are always the minimum edges
// of the bounding box so we can take advantage of that
export const POSITION_SUBSTITUTES = {
	bottom: 'left',
	left: 'top',
	right: 'top',
	top: 'left'
};

export const RELATED_DIMENSION = {
	bottom: 'height',
	left: 'width',
	right: 'width',
	top: 'height'
};